import React, { useEffect, useRef, useState } from 'react';

export function ActivityPanel({ state, onAction }) {
  const [message, setMessage] = useState('');
  const chatEnd = useRef(null);

  useEffect(() => {
    chatEnd.current?.scrollIntoView({ behavior: 'smooth' });
  }, [state.chat.length]);

  function send(event) {
    event.preventDefault();
    if (!message.trim()) return;
    onAction('chat:send', { message });
    setMessage('');
  }

  return (
    <aside className="activity-panel">
      <details open>
        <summary>Spielverlauf <span>{state.log.length}</span></summary>
        <div className="activity-list">
          {[...state.log].slice(-35).reverse().map((entry) => <p key={entry.id} className={`activity activity--${entry.type}`}><time>{new Date(entry.at).toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' })}</time><span>{entry.text}</span></p>)}
        </div>
      </details>
      <details>
        <summary>Chat <span>{state.chat.length}</span></summary>
        <div className="chat-list">
          {state.chat.length === 0 && <p className="muted">Noch keine Nachrichten.</p>}
          {state.chat.map((item) => <p className="chat-message" key={item.id}><strong>{item.name}</strong><span>{item.message}</span></p>)}
          <div ref={chatEnd} />
        </div>
        <form className="chat-form" onSubmit={send}>
          <input value={message} onChange={(event) => setMessage(event.target.value.slice(0, 240))} placeholder="Nachricht …" maxLength={240} />
          <button className="icon-button" aria-label="Senden">➤</button>
        </form>
      </details>
    </aside>
  );
}
